import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable()
export class DateInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          return event.clone({
            body: this.convertDates(event.body)
          });
        }
        return event;
      })
    );
  }

  private convertDates(obj: any): any {
    if (obj === null || obj === undefined) return obj;

    // Se è una stringa ISO → converto
    if (typeof obj === 'string' && this.isIsoDate(obj)) {
      return new Date(obj);
    }

    // Se è un array → converto ogni elemento
    if (Array.isArray(obj)) {
      return obj.map(item => this.convertDates(item));
    }

    // Se è un oggetto → converto ogni proprietà
    if (typeof obj === 'object') {
      const converted: any = {};
      for (const key of Object.keys(obj)) {
        converted[key] = this.convertDates(obj[key]);
      }
      return converted;
    }

    return obj;
  }

  private isIsoDate(value: string): boolean {
    // Riconosce formati ISO come "2024-01-10T12:34:56.789Z"
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value);
  }
}
